import {VGNav} from "vgnav";
import {VGSpy} from "vgscrollto";
import {VGSidebar} from "vgnav/src/VGSidebar";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.fixedHeader($(window));
		VG.plugins.init();
		VG.ScrollToTop.init($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop(),
			offset = $sticky.height(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}

		if ($body.hasClass('header--is-fixed')) {
			$('.widgets-sticky, .sticky').css('top', offset + 10);
		} else {
			$('.widgets-sticky, .sticky').css('top', 10);
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableVGSpy();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'md',
				toggle: '<i class="fa fa-chevron-down"></i>'
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableVGSpy: function ()  {
			let $VGSpy =document.getElementById('vg-nav-spy');
			if ($VGSpy && window.innerWidth < 1000) {
				new VGSpy($VGSpy, {
					offset: -60,
					onClick: function (e, self) {
						let target = 'vg-nav-sidebar';

						if (document.getElementById(target)) {
							let sidebar = new VGSidebar(target);
							sidebar.close();
						}

						$('.vg-nav-hamburger').removeClass('show');

						return false;
					}
				})
			}
		},

		enableNiceSelect: function ()  {
			$('.nice-select').niceSelect();
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	}
}


export default VGListener;